import { LoadingBar } from '@/components/LoadingBar';
import { getPeaks } from '@/service/audioList';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import { cn } from '@/utils';
import { useWavesurfer } from '@wavesurfer/react';
import { useRequest } from 'ahooks';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';

interface WaveFormProps {
  songId: string
  duration: number
}

export const WaveForm: React.FC<WaveFormProps> = ({ songId, duration }) => {
  const { data, loading } = useRequest(() => getPeaks({ songId }))
  const peaks = data?.data?.peaks
  const containerRef = useRef(null);
  const { playAudioInfo, wave } = useAudioPlayerStore()
  const isCurrentSong = playAudioInfo?.id === songId
  const { currentTime } = useAudioPlayerStore();
  const [waveSurfer, setWaveSurfer] = useState<WaveSurfer | null>(null)
  useEffect(() => {
    if (containerRef.current && peaks?.length) {
      const waveSurfer = WaveSurfer.create({
        container: containerRef.current,
        barRadius: 1,
        cursorColor: 'transparent',
        height: 'auto',
        fillParent: true,
        hideScrollbar: true,
        progressColor: '#FF5b27',
        barHeight: 0.9,
        waveColor: '#67666d',
        normalize: false,
        sampleRate: 48000,
        peaks,
        duration, //use pre-decoded must have
      });
      setWaveSurfer(waveSurfer)
    }


  }, [containerRef, peaks])



  useEffect(() => {
    if (waveSurfer) {
      waveSurfer?.setTime(currentTime);
    }

  }, [currentTime, waveSurfer, isCurrentSong]);
  const handleChangeDuration = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      if (!playAudioInfo?.duration) return;
      const rect = e.currentTarget.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const width = rect.width;
      const percentage = clickX / width;
      const newTime = percentage * playAudioInfo.duration;
      wave?.wavesurfer?.setTime(newTime)
    },
    [playAudioInfo, wave]
  );

  return (
    <div className=" overflow-hidden w-full">
      <div
        ref={containerRef}
        className={cn(
          'lg:block relative h-full flex-1 w-full cursor-pointer',
        )}
        onClick={e => handleChangeDuration(e)}
      >
        <div className={cn("absolute   transition-all z-30 w-full h-full ", {
          // "dotted-waveform ": loading
        })}></div>
        {/* {loading && <LoadingBar className=" w-full h-14 " />} */}
      </div>
    </div>
  );
};
